<template>
  <div :class="['flex items-center gap-3 px-4 py-3 rounded-xl border text-sm', styles.wrap]" role="alert">
    <span class="material-icons text-lg" aria-hidden="true">{{ styles.icon }}</span>
    <p class="flex-1">{{ message }}</p>
    <slot name="action"></slot>
    <button
      v-if="dismissible"
      type="button"
      @click="$emit('dismiss')"
      :class="['transition-colors', styles.close]"
      aria-label="Dismiss"
    >
      <span class="material-icons text-lg" aria-hidden="true">close</span>
    </button>
  </div>
</template>

<script>
import { computed } from 'vue'

const TYPES = {
  success: {
    wrap: 'bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-800/40 text-emerald-700 dark:text-emerald-300',
    icon: 'check_circle',
    close: 'text-emerald-400 hover:text-emerald-600 dark:hover:text-emerald-300',
  },
  error: {
    wrap: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800/40 text-red-700 dark:text-red-300',
    icon: 'error_outline',
    close: 'text-red-400 hover:text-red-600 dark:hover:text-red-300',
  },
  info: {
    wrap: 'bg-secondary-50 dark:bg-secondary-900/20 border-secondary-200 dark:border-secondary-800/40 text-secondary-700 dark:text-secondary-300',
    icon: 'info',
    close: 'text-secondary-400 hover:text-secondary-600 dark:hover:text-secondary-300',
  },
}

export default {
  name: 'AlertBanner',
  props: {
    type: { type: String, default: 'info' },
    message: { type: String, default: '' },
    dismissible: { type: Boolean, default: true },
  },
  emits: ['dismiss'],
  setup(props) {
    const styles = computed(() => TYPES[props.type] || TYPES.info)
    return { styles }
  },
}
</script>
